export enum ArithmeticalOperatorSymbol {
  sum = '+',
  subtract = '-',
  multiply = '*',
  divide = '/',
}
